export const FETCH_CATALOG_LOTS_PENDING = 'BULK_BIDDING/FETCH_CATALOG_LOTS_PENDING';
export const FETCH_CATALOG_LOTS_SUCCESS = 'BULK_BIDDING/FETCH_CATALOG_LOTS_SUCCESS';
export const FETCH_BID_HISTORY_SUCCESS = 'BULK_BIDDING/FETCH_BID_HISTORY_SUCCESS';
export const FETCH_SALE_INFO = 'BULK_BIDDING/FETCH_SALE_INFO';
export const FETCH_SELECTED_LOTS = 'BULK_BIDDING/FETCH_SELECTED_LOTS';
export const UPDATE_BIDS_DATA = 'BULK_BIDDING/UPDATE_BIDS_DATA';
export const FETCH_PLACED_LOTS_DATA = 'BULK_BIDDING/FETCH_PLACED_LOTS_DATA';
export const SUBMIT_PLACED_BIDS = 'BULK_BIDDING/SUBMIT_PLACED_BIDS';
export const FETCH_BID_HISTORY = 'BULK_BIDDING/FETCH_BID_HISTORY';
export const CLEAR_BID_HISTORY = 'BULK_BIDDING/CLEAR_BID_HISTORY';
export const CLEAR_BULK_BIDDING_DATA = 'BULK_BIDDING/CLEAR_BULK_BIDDING_DATA';
export const THROW_API_ERROR = 'BULK_BIDDING/THROW_API_ERROR';
export const CLEAR_CATALOG_LOTS = 'CLEAR_CATALOG_LOTS';

const BID_CANCEL_LIMIT = 10;

const initialState = {
  catalogLots: [],
  lastOrderedPage: -1,
  unorderedCatalogLots: {},
  selectedLots: {},
  saleInfo: {},
  bidHistory: [],
  selectedBids: {},
  placedLotsData: [],
  submitBidsData: {
    successBids: [],
    failedBids: [],
  },
  canBidInfo: '',
  lotsLoading: true,
  totalPagesToFetch: 0,
  catalogLotsFetchGeneration: 0,
  lotBidHistoryLoading: false,
  canCancelBid: false,
  apiError: '',
};

const getOrderedLots = (unorderedLots, lastOrderedPage) => {
  const pages = Object.keys(unorderedLots);

  const catalogLots = [];

  for (let i = 0; i < pages.length; i++) {
    const page = +pages[i];
    if (lastOrderedPage + 1 === page) {
      const value = unorderedLots[page];
      catalogLots.push(...value);
      lastOrderedPage += 1;
      delete unorderedLots[pages[i]];
    } else {
      break;
    }
  }

  return [lastOrderedPage, catalogLots];
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CATALOG_LOTS_PENDING: {
      const { totalPages, catalogLotsFetchGeneration } = action.payload;
      return {
        ...state,
        catalogLots: initialState.catalogLots,
        unorderedCatalogLots: initialState.unorderedCatalogLots,
        lastOrderedPage: -1,
        totalPagesToFetch: totalPages,
        catalogLotsFetchGeneration,
        lotsLoading: true
      };
    }
    case FETCH_CATALOG_LOTS_SUCCESS: {
      const { data, pageNumber, catalogLotsFetchGeneration } = action.payload;
      // A page from a superseded load (double-click / auto-load race) — drop it,
      // don't let it touch the current load's counter.
      if (catalogLotsFetchGeneration !== state.catalogLotsFetchGeneration) return state;

      const unorderedLots = { ...state.unorderedCatalogLots };
      unorderedLots[pageNumber] = data;

      const pendingPages = state.totalPagesToFetch - 1;
      const [lastOrderedPage, catalogLots] = getOrderedLots(unorderedLots, state.lastOrderedPage);
      const updatedCatalogLots = catalogLots.length > 0 ? [...state.catalogLots, ...catalogLots] : state.catalogLots;
      const lotsLoading = pendingPages !== 0;

      return {
        ...state,
        lastOrderedPage,
        unorderedCatalogLots: unorderedLots,
        catalogLots: updatedCatalogLots,
        totalPagesToFetch: pendingPages,
        lotsLoading
      };
    }
    case FETCH_SALE_INFO:
      return {
        ...state,
        saleInfo: action.payload,
      };
    case FETCH_BID_HISTORY:
      return {
        ...state,
        lotBidHistoryLoading: true
      };

    case FETCH_BID_HISTORY_SUCCESS:
      return {
        ...state,
        lotBidHistoryLoading: false,
        bidHistory: action.payload.bidHistory,
        canCancelBid: action.payload.cancelBidCount < BID_CANCEL_LIMIT
      };
    case CLEAR_BID_HISTORY:
      return {
        ...state,
        bidHistory: initialState.bidHistory
      };
    case FETCH_SELECTED_LOTS:
      return {
        ...state,
        selectedLots: action.payload,
        apiError: initialState.apiError,
      };
    case UPDATE_BIDS_DATA: {
      const [lotRef, value] = action.payload;
      const selectedBids = { ...state.selectedBids };
      if (!value) {
        delete selectedBids[lotRef];
      } else {
        selectedBids[lotRef] = value;
      }
      return {
        ...state,
        selectedBids
      };
    }
    case FETCH_PLACED_LOTS_DATA:
      return {
        ...state,
        placedLotsData: action.payload,
      };
    case SUBMIT_PLACED_BIDS:
      return {
        ...state,
        submitBidsData: action.payload,
        placedLotsData: initialState.placedLotsData,
        selectedBids: initialState.selectedBids,
        apiError: initialState.apiError,
      };
    case CLEAR_BULK_BIDDING_DATA:
      return {
        ...state,
        ...initialState,
      };
    case THROW_API_ERROR:
      return {
        ...state,
        lotBidHistoryLoading: false,
        apiError: action.payload,
        lotsLoading: false
      };
    case CLEAR_CATALOG_LOTS:
      return {
        ...state,
        catalogLots: initialState.catalogLots,
      };
    default:
      return state;
  }
};

export const clearBidHistory = () => ({
  type: CLEAR_BID_HISTORY
});

export const clearCatalogLots = () => ({
  type: CLEAR_CATALOG_LOTS
});
